module.exports = __webpack_public_path__ + "static/media/bn_wix_editing.c9a0db27.png";